/**
 * 报价单状态映射的单一来源（列表页与详情页共用）。
 * 新增状态值时只改这里，两页标签/颜色不会再各自漂移。
 */
export const QUOTATION_STATUS_TEXT = {
  DRAFT: '草稿',
  PENDING_CONFIRM: '待确认',
  SENT: '已发送',
  ACCEPTED: '已接受',
  REJECTED: '已拒绝',
  ARCHIVED: '历史存档',
};

export const QUOTATION_STATUS_COLOR = {
  DRAFT: 'default',
  PENDING_CONFIRM: 'warning',
  SENT: 'primary',
  ACCEPTED: 'success',
  REJECTED: 'error',
  ARCHIVED: 'default',
};

export const QUOTATION_STATUS_LIST = [
  { value: '', label: '全部' },
  { value: 'DRAFT', label: '草稿' },
  { value: 'PENDING_CONFIRM', label: '待确认' },
  { value: 'SENT', label: '已发送' },
  { value: 'ACCEPTED', label: '已接受' },
  { value: 'REJECTED', label: '已拒绝' },
  { value: 'ARCHIVED', label: '历史存档' },
];

// 状态机（与后端 quotation-status.js STATUS_TRANSITIONS 保持同构；改动须两侧同步）
export const STATUS_TRANSITIONS = {
  DRAFT: ['PENDING_CONFIRM', 'SENT'],
  PENDING_CONFIRM: ['SENT', 'REJECTED', 'DRAFT'],
  SENT: ['ACCEPTED', 'REJECTED'],
  REJECTED: ['DRAFT'],
};

export function nextStatuses(status) {
  return STATUS_TRANSITIONS[status] || [];
}

export function getStatusText(status) {
  return QUOTATION_STATUS_TEXT[status] || status;
}

export function getStatusColor(status) {
  return QUOTATION_STATUS_COLOR[status] || 'default';
}
